export default "__VITE_ASSET__mYKNOpkK__"